import React, { Component, PropTypes } from 'react';
import ga from 'react-ga';
import createFragment from 'react-addons-create-fragment';
import CargosConstants from 'constants/Cargos';
import { CargoType, CategoryType } from 'types';
import { translate as t } from 'lang';
import ActionCreators from 'actions/ActionCreators';
import EditingCargoStore from 'stores/EditingCargoStore';
import GeneralStore from 'stores/GeneralStore';
import Modal from 'components/Modal';
import { createControlFactory } from 'components/Controls';
import CommonCargoAttributesPane from 'components/CommonCargoAttributesPane';
import SelectControl from 'components/SelectControl';
import RadioControl from 'components/RadioControl';
import SuggestControl from 'components/SuggestControl';
import TipControl from 'components/TipControl';
import { cancelablePromise } from 'core/utils';
import { getCargoNames, getBrands, getModels } from 'api';
import ShallowCompare from 'react-addons-shallow-compare';

import './CargoDialog.scss';

var getCargoNamesPromise = null;
var getBrandsPromise = null;
var getModelsPromise = null;
var tankmenErrors = {};

class CargoDialog extends Component {

    static propTypes = {
        /**
         * Редактируемый груз.
         * @type {CargoType}
         */
        cargo: PropTypes.instanceOf(CargoType).isRequired,
        selectedCategory: PropTypes.instanceOf(CategoryType).isRequired,
    }

    state = {
        suggestions: [],
        brandSuggestions: [],
        modelSuggestions: [],
    }

    constructor(props) {
        super(props);

        this.Control = createControlFactory(ActionCreators.updateEditingCargo);
        this._onNameSuggestionSelected = this._onNameSuggestionSelected.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ShallowCompare(this, nextProps, nextState);
    }

    componentDidMount() {
        var cargo = this.props.cargo;
        var attributes = {};

        /** @todo Костыль для значения по умолчанию (наливные и сыпучие грузы) */
        if (this.props.selectedCategory.id === 'liquid' || this.props.selectedCategory.id === 'loose') {
            if (cargo.attributes.has("unit_of_measurement")) attributes.unit_of_measurement = [CargosConstants.UNITS.M];
        }
        if (cargo.attributes.has("is_working") && cargo.attributes.get("is_working").get("value") == undefined) attributes.is_working = true;

        // If subcategory is true cargo, then we find it's dimensions and set the name right away
        if (cargo.attributes.has('name') &&
            !cargo.attributes.getIn(['name', 'value']) &&
            cargo.is_true_cargo &&
            this.props.selectedCategory.name !== 'moving' &&
            this.props.selectedCategory.name !== 'moving_cian') {

            attributes.name = cargo.name;
            ActionCreators.showLoadingOverlay();

            this._getNameSuggestions({ value: cargo.name }, true)
                .then((suggestions) => {
                    ActionCreators.hideLoadingOverlay();

                    if (!suggestions || !suggestions[0]) {
                        return;
                    }

                    this._onNameSuggestionSelected(null, { suggestion: suggestions[0] });
                });
        }

        ActionCreators.updateEditingCargo(attributes);

        // Focus name input in cargo dialog
        if (this._cargoNameInputDOMnode && !GeneralStore.isLoading()) {
            this._cargoNameInputDOMnode.focus();
        }
    }

    componentWillUnmount() {

        // Cancel request promises
        getCargoNamesPromise && typeof getCargoNamesPromise.cancel === 'function' ? getCargoNamesPromise.cancel() : false;
        getBrandsPromise && typeof getBrandsPromise.cancel === 'function' ? getBrandsPromise.cancel() : false;
        getModelsPromise && typeof getModelsPromise.cancel === 'function' ? getModelsPromise.cancel() : false;
    }

    _onDialogClose = (type, target) => {

        if (type === 'cancelCargoDialog' && (target === 'cancel' || target === 'close')) {
            ga.event({
                category: 'buttons',
                action: 'cancel',
                label: this.props.selectedCategory.name,
                value: 1
            });
        }

        tankmenErrors = {};

        ActionCreators.cancelCargoEditing();
    };

    _onDialogSave = (modal) => {
        // Если объем вводится напрямую в input, а не рассчитывается, и если пользователь ввел слишком маленькое значение,
        // то подменяем его на 0.01м3
        var cargo = this.props.cargo;
        if (cargo.attributes.has('volume')) {

            var volume = cargo.attributes.getIn(['volume', 'value']);
            if (volume) {
                var units = CargosConstants.UNITS.M;
                if (cargo.attributes.has('unit_of_measurement')) {
                    var units_value = cargo.attributes.getIn(['unit_of_measurement', 'value']);
                    if (units_value) {
                        units = cargo.attributes.getIn(['unit_of_measurement', 'value'])[0];
                    }
                }
            }
        }

        let tankmenErrorsValues = Object.values(tankmenErrors);

        // ASC
        tankmenErrorsValues.sort(function (a, b) { return a - b });
        if (tankmenErrorsValues[0]) {
            ActionCreators.cancelTankmenValidation();
        } else {
            ActionCreators.enableTankmenValidation();
        }

        ActionCreators.showLoadingOverlay();

        EditingCargoStore.validate().then(
            done => {
                tankmenErrors = {};

                ga.event({
                    category: 'buttons',
                    action: 'save',
                    label: this.props.selectedCategory.name,
                    value: 1
                });

                ActionCreators.enableTankmenValidation();
                ActionCreators.sendAttributesToGa();
                ActionCreators.stopCargoEditing();
                ActionCreators.hideLoadingOverlay();
                modal.modal('hide');
            },
            error => {
                for (let key in error) {
                    let value = error[key];

                    let tankmenErrorsKey = this.props.cargo.get('name') + '_' + key;
                    let attempts = tankmenErrors[tankmenErrorsKey];

                    if (value === 'DIMENSIONS_DO_NOT_CORRESPOND_WEIGHT'
                        || value.indexOf(t('UNITS_TOO_LARGE_VALUE_PERHAPS_YOU_MEAN')) >= 0) {

                        if (attempts && Number.isInteger(attempts)) {
                            attempts += 1;
                        } else {
                            attempts = 1;
                        }

                        Object.assign(tankmenErrors, { [tankmenErrorsKey]: attempts });
                    }
                }

                ActionCreators.hideLoadingOverlay();
            }
        );
    }

    _onChangeDimensions = () => {
        tankmenErrors = {};
        ActionCreators.hideApproximateUnitsWarning();
    }

    _suggestionRenderer = (suggestion) => {
        if (!suggestion) {
            return '';
        }

        return suggestion.value;
    }

    _suggestionValue = (suggestion) => {
        if (!suggestion) {
            return '';
        }

        return suggestion.value;
    }

    _onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
            modelSuggestions: [],
            brandSuggestions: [],
        });
    }

    _onModelSuggestionsClearRequested = () => {
        this.setState({
            modelSuggestions: [],
        });
    }

    _onBrandSuggestionsClearRequested = () => {
        this.setState({
            brandSuggestions: [],
        });
    }

    _getNameSuggestions = (query, strict = false) => {
        query = query.value;
        getCargoNamesPromise = cancelablePromise(getCargoNames(query, strict));

        return getCargoNamesPromise
            .promise
            .then(data => {
                let suggestions = [];

                if (data.response) {
                    for (var id in data.response) {
                        if (!data.response.hasOwnProperty(id)) continue;
                        const suggestion = data.response[id];
                        suggestions.push({ id: suggestion.id, value: suggestion.name, data: suggestion });
                    }
                }

                if (suggestions.length > 0) {
                    this.setState({ suggestions });
                }

                return suggestions;
            })
            .catch(error => { });
    }

    _onNameSuggestionSelected(event,  { suggestion }) {
        if (!suggestion) {
            return;
        }

        if (!suggestion.data) {
            return;
        }

        // // Focus name input in cargo dialog
        // if (this._cargoNameInputDOMnode && event) {
        //
        // 	// If you call HTMLElement.focus() from a mousedown event handler,
        // 	// you must call event.preventDefault() to keep the focus from leaving the HTMLElement.
        // 	// Moreover, we focus input manualy because input ref in function.
        // 	event.preventDefault();
        // 	this._cargoNameInputDOMnode.focus();
        // }

        const cargo = this.props.cargo;
        const attributes = suggestion.data.attributes;

        if (!attributes) {
            return;
        }

        let cargoAttributes = {};
        for (let i = 0; i < attributes.length; i++) {
            const attribute = attributes[i];
            cargoAttributes[attribute.name] = attribute.value;
        }

        if (Object.keys(cargoAttributes).length > 0 &&
            (cargoAttributes.width > 0 ||
                cargoAttributes.length > 0 ||
                cargoAttributes.height > 0 ||
                cargoAttributes.volume > 0 ||
                cargoAttributes.weight > 0)) {
            ActionCreators.showApproximateUnitsWarning();
        } else {
            if (this.props.selectedCategory.id !== 'liquid' && this.props.selectedCategory.id !== 'loose') {
                cargoAttributes.width = undefined;
                cargoAttributes.length = undefined;
                cargoAttributes.height = undefined;
            }

            cargoAttributes.volume = undefined;
            cargoAttributes.weight = undefined;
            cargoAttributes.unit_of_measurement = [CargosConstants.UNITS.CM];
            ActionCreators.hideApproximateUnitsWarning();
        }

        // HACK: если выбрана категория "Наливные грузы" или "насыпные грузы" и через Autosuggest
        // добавляется груз, то если у груза единицы измерения — см/кг, перед выводом они
        // переводятся в м/т
        if (
            cargoAttributes.unit_of_measurement &&
            cargoAttributes.unit_of_measurement[0] &&
            cargoAttributes.unit_of_measurement[0] === CargosConstants.UNITS.CM &&
            (this.props.selectedCategory.id === 'liquid' || this.props.selectedCategory.id === 'loose')
        ) {
            if (cargoAttributes.volume) {
                cargoAttributes.volume /= 1e6;
            }

            if (cargoAttributes.weight) {
                cargoAttributes.weight /= 1e3;
            }
        }
        //
        // end of HACK
        //
        
        // Not consistent data from server
        if (cargoAttributes.unit_of_measurement === undefined) {
            cargoAttributes.unit_of_measurement = [CargosConstants.UNITS.CM]
        }

        ActionCreators.updateEditingCargoId(suggestion.id);
        ActionCreators.updateEditingCargo(cargoAttributes);
    }

    _getBrandSuggestions = (query) => {
        query = query.value;

        getBrandsPromise = cancelablePromise(getBrands(query));
        getBrandsPromise
            .promise
            .then(data => {
                let suggestions = [];

                if (data.response) {
                    for (var id in data.response) {
                        if (!data.response.hasOwnProperty(id)) continue;
                        suggestions.push({ value: data.response[id].title });
                    }
                }

                if (suggestions.length > 0) {
                    this.setState({
                        brandSuggestions: suggestions,
                    });
                }
            })
            .catch(error => { });
    }

    _getModelSuggestions = (query) => {
        query = query.value;

        const brandName = this.props.cargo.attributes.getIn(['auto_brand', 'value']);
        if (!brandName) {
            return false;
        }

        getModelsPromise = cancelablePromise(getModels(query, brandName));
        getModelsPromise
            .promise
            .then(data => {
                let suggestions = [];

                if (data.response) {
                    for (var id in data.response) {
                        if (!data.response.hasOwnProperty(id)) continue;
                        suggestions.push({ value: data.response[id].title });
                    }
                }

                if (suggestions.length > 0) {
                    this.setState({
                        modelSuggestions: suggestions,
                    });
                }
            })
            .catch(error => { });
    }

    _onChangeName = (event, data) => {
        ActionCreators.updateEditingCargo({ name: data.newValue });
    }

    _onChangeBrand = (event, data) => {
        ActionCreators.updateEditingCargo({ auto_brand: data.newValue });
    }

    _onChangeModel = (event, data) => {
        ActionCreators.updateEditingCargo({ auto_model: data.newValue });
    }

    _onChangeYearOfManufacture = (event, val) => {
        val = parseInt(val);
        if (val === 0) {
            val = undefined;
        }
        ActionCreators.updateEditingCargo({ 'year_of_manufacture': val });
    }

    _onChangeIsWorking = (e, val) => {
        var isWorking = Boolean(parseInt(val));
        ActionCreators.updateEditingCargo({ 'is_working': isWorking });
    }

    _setCargoNameInputRef = (inputDOMnode) => {
        this._cargoNameInputDOMnode = inputDOMnode;
    }

    render() {
        const {cargo} = this.props;

        var attributes = cargo.attributes;

        // Sort attributes in ImmutableMap by id
        attributes = attributes.sortBy((value, key) => {
            return value.id;
        });

        // Hack to move attribute "name" to the first place in sequence
        var name = attributes.filter(value => {
            return value.id === 23;
        });
        var others = attributes.filterNot(value => {
            return value.id === 23;
        });
        attributes = name.merge(attributes);

        var validationResult = attributes.map(attribute => {
            if (attribute.error) {
                // Не отображать ошибку объема, если объем рассчитывается через длину ширину и высоту
                if (attribute.name === 'volume' && attributes.has('length') && attributes.has('width') && attributes.has('height')) {
                    return;
                }

                return (
                    <div className="CargoDialog-validationError">
                        {attribute.title}: {t(attribute.error)}
                    </div>
                );
            }
        }).toJS();

        // Cargo main attributes (name and quantity)
        let mainAttributes = {};

        if (cargo.attributes.has('name')) {
            const nameAttribute = cargo.attributes.get('name');

            mainAttributes.name = (
                <div className="CargoDialog-item -name">
                    <SuggestControl
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this._getNameSuggestions}
                        renderSuggestion={this._suggestionRenderer}
                        getSuggestionValue={this._suggestionValue}
                        onSuggestionsClearRequested={this._onSuggestionsClearRequested}
                        inputProps={{
                            label: nameAttribute.get('title'),
                            id: nameAttribute.get('name'),
                            placeholder: "Начните вводить название груза",
                            error: nameAttribute.error && "Пожалуйста, укажите наименование",
                            onChange: this._onChangeName,
                            inputRef: this._setCargoNameInputRef,
                            value: nameAttribute.get('value') || '',
                        }}
                        focusInputOnSuggestionClick={false}
                        onSuggestionSelected={this._onNameSuggestionSelected} />
                </div>
            );
        }

        if (cargo.attributes.has('auto_brand')) {
            const brandAttribute = cargo.attributes.get('auto_brand');

            mainAttributes.auto_brand = (
                <div className="CargoDialog-item -auto_brand">
                    <SuggestControl
                        suggestions={this.state.brandSuggestions}
                        onSuggestionsFetchRequested={this._getBrandSuggestions}
                        renderSuggestion={this._suggestionRenderer}
                        getSuggestionValue={this._suggestionValue}
                        onSuggestionsClearRequested={this._onBrandSuggestionsClearRequested}
                        focusInputOnSuggestionClick={false}
                        inputProps={{
                            label: brandAttribute.get('title'),
                            id: brandAttribute.get('name'),
                            placeholder: "Начните вводить",
                            error: brandAttribute.error && "Пожалуйста, укажите марку",
                            onChange: this._onChangeBrand,
                            value: brandAttribute.get('value') || '',
                        }} />
                </div>
            );
        }

        if (cargo.attributes.has('auto_model')) {
            const modelAttribute = cargo.attributes.get('auto_model');

            mainAttributes.auto_model = (
                <div className="CargoDialog-item -auto_model">
                    <SuggestControl
                        suggestions={this.state.modelSuggestions}
                        onSuggestionsFetchRequested={this._getModelSuggestions}
                        renderSuggestion={this._suggestionRenderer}
                        getSuggestionValue={this._suggestionValue}
                        onSuggestionsClearRequested={this._onModelSuggestionsClearRequested}
                        focusInputOnSuggestionClick={false}
                        inputProps={{
                            label: modelAttribute.get('title'),
                            id: modelAttribute.get('name'),
                            placeholder: "Начните вводить",
                            error: modelAttribute.error && "Пожалуйста, укажите модель",
                            onChange: this._onChangeModel,
                            value: modelAttribute.get('value') || '',
                        }} />
                </div>
            );
        }

        if (cargo.attributes.has('number_of_persons')) {
            mainAttributes.number_of_persons = (
                <div className="CargoDialog-item -number_of_persons">
                    <this.Control
                        type="number"
                        attribute={cargo.attributes.get('number_of_persons')} />
                </div>
            );
        }

        if (cargo.attributes.has('number_of_hours') && cargo.get("id") != 85) {
            mainAttributes.number_of_hours = (
                <div className="CargoDialog-item -number_of_hours">
                    <this.Control
                        type="number"
                        attribute={cargo.attributes.get('number_of_hours')} />
                </div>
            );
        }

        if (cargo.attributes.has('year_of_manufacture')) {
            var yearParam = cargo.attributes.get('year_of_manufacture');
            var yearOptions = [];
            var lastYear = (new Date().getFullYear());
            yearOptions.push({ value: 0, label: 'Не выбран' });
            for (var i = lastYear; i >= 1900; i--) {
                yearOptions.push({ value: i.toString(), label: i.toString() });
            }
            mainAttributes.year_of_manufacture = (
                <div className="CargoDialog-item -year_of_manufacture">
                    <SelectControl
                        label={yearParam.title}
                        options={yearOptions}
                        value={yearParam.value ? yearParam.value.toString() : 0}
                        onChange={this._onChangeYearOfManufacture} />
                </div>
            );
        }

        // Дополнительные аттрибуты груза — размеры, вес, мобильность.
        var additinalAttributes = {};

        if ((cargo.attributes.has('width') ||
            cargo.attributes.has('height') ||
            cargo.attributes.has('length') ||
            cargo.attributes.has('weight') ||
            cargo.attributes.has('volume') ||
            cargo.attributes.has('unit_of_measurement')
        ) && cargo.attributes.getIn(['unit_of_measurement', 'values'])) {
            var attributes = {};
            var categoriesWithoutLWH = this.props.selectedCategory.id === 'liquid' || this.props.selectedCategory.id === 'loose' || this.props.selectedCategory.id === 'rubbish'; // категории без ДШВ

            if (cargo.attributes.has('width') && !categoriesWithoutLWH) attributes.width = cargo.attributes.get('width');
            if (cargo.attributes.has('height') && !categoriesWithoutLWH) attributes.height = cargo.attributes.get('height');
            if (cargo.attributes.has('length') && !categoriesWithoutLWH) attributes.length = cargo.attributes.get('length');
            if (cargo.attributes.has('weight')) attributes.weight = cargo.attributes.get('weight');
            if (cargo.attributes.has('volume')) attributes.volume = cargo.attributes.get('volume');
            if (cargo.attributes.has('unit_of_measurement') && (this.props.selectedCategory.id !== 'liquid' || this.props.selectedCategory.id !== 'loose')) attributes.unit_of_measurement = cargo.attributes.get('unit_of_measurement');

            additinalAttributes.dimensions = (
                <div className="CargoDialog-item">

                    {cargo.get('show_approximate_units_warning') ?
                        <div className="CargoDialog-warningText">{t('APPROXIMATE_UNITS_WARNING')}</div>
                        : ''}

                    <this.Control type="dimensions"
                        onChange={this._onChangeDimensions}
                        selectedCategory={this.props.selectedCategory}
                        quantity={cargo.attributes.getIn(['quantity', 'value']) || 1}
                        attributes={attributes} />
                </div>
            );
        }

        if (cargo.attributes.has('quantity')) {
            additinalAttributes.quantity = (
                <div className="CargoDialog-item -number">
                    <this.Control type="number"
                        minValue={1}
                        attribute={cargo.attributes.get('quantity')} />
                </div>
            );
        }

        if (cargo.attributes.has('quantity')
            && cargo.attributes.has('volume')
            && cargo.attributes.getIn(['unit_of_measurement', 'values'])) {

            let volume = cargo.attributes.getIn(['volume', 'value']) || 0;
            let quantity = cargo.attributes.getIn(['quantity', 'value']) || 1;
            let unitsOfMeasurement = cargo.attributes.getIn(['unit_of_measurement', 'value']) || [CargosConstants.UNITS.CM];

            if (unitsOfMeasurement[0] === CargosConstants.UNITS.CM) {
                volume /= 1e6;
            }

            additinalAttributes.totalVolume = (
                <div className="CargoDialog-item -totalVolume">
                    <div className="CargoDialog-item -totalVolumeTitle">Общий объем</div>
                    <div className="CargoDialog-item -totalVolumeValue">
                        {parseFloat((quantity * volume).toFixed(2)) + ' м³'}
                    </div>
                </div>
            );
        }

        if (cargo.attributes.has('quantity')
            && cargo.attributes.has('weight')
            && cargo.attributes.getIn(['unit_of_measurement', 'values'])) {

            let weight = cargo.attributes.getIn(['weight', 'value']) || 0;
            let quantity = cargo.attributes.getIn(['quantity', 'value']) || 1;
            let unitsOfMeasurement = cargo.attributes.getIn(['unit_of_measurement', 'value']) || [CargosConstants.UNITS.CM];

            let unitsStr = t('KG');
            if (unitsOfMeasurement[0] === CargosConstants.UNITS.M) {
                unitsStr = t('T');
            }

            additinalAttributes.totalWeight = (
                <div className="CargoDialog-item -totalWeight">
                    <div className="CargoDialog-item -totalWeightTitle">Общий вес</div>
                    <div className="CargoDialog-item -totalWeightValue">
                        {parseFloat((quantity * weight).toFixed(2)) + ' ' + unitsStr}
                    </div>
                </div>
            );
        }

        additinalAttributes.inline = (
            <div className="CargoDialog-item">
                {cargo.attributes.has('disassembly') ? (
                    <div className="CargoDialog-inline CargoDialog-mobileMarginBottom">
                        <this.Control type="checkbox"
                            attribute={cargo.attributes.get('disassembly')} />
                    </div>
                ) : ''}
                {cargo.attributes.has('not_fit_elevator') ? (
                    <div className="CargoDialog-inline CargoDialog-mobileMarginBottom">
                        <this.Control type="checkbox"
                            attribute={cargo.attributes.get('not_fit_elevator')} />
                    </div>
                ) : ''}
            </div>
        );

        if (cargo.attributes.has('is_working')) {
            var isWorking = cargo.attributes.get("is_working").get("value");
            var wheelsSpinning = null;

            if (!isWorking && cargo.attributes.has('wheels_are_spinning')) {
                wheelsSpinning = (
                    <div className="CargoDialog-inline">
                        <this.Control type="checkbox"
                            attribute={cargo.attributes.get('wheels_are_spinning')} />
                    </div>
                );
            }

            additinalAttributes.is_working = (
                <div className="CargoDialog-item">
                    <div className="CargoDialog-inline CargoDialog-mobileMarginBottom">
                        <RadioControl name="is_working" label="На ходу"
                            value="1"
                            checked={Boolean(isWorking)}
                            onChange={this._onChangeIsWorking} />
                    </div>
                    <div className="CargoDialog-inline">
                        <RadioControl name="is_working" label="Не на ходу"
                            value="0"
                            checked={!Boolean(isWorking)}
                            onChange={this._onChangeIsWorking} />
                    </div>
                    {wheelsSpinning}
                </div>
            );
        }

        if (cargo.attributes.has('with_trailer')) {
            var withTrailer = cargo.attributes.get("with_trailer").get("value");
            var towBarType = null;

            if (withTrailer && cargo.attributes.has('tow_bar_type')) {
                var towBarTypeAttribute = cargo.attributes.get('tow_bar_type');
                towBarType = (
                    <div className="CargoDialog-inline">
                        <this.Control
                            type="select"
                            withoutLabel={true}
                            options={Object.values(towBarTypeAttribute.values).map(option => { return { value: option.id, label: option.value }; })}
                            attribute={towBarTypeAttribute} />
                    </div>
                );
            }

            additinalAttributes.with_trailer = (
                <div className="CargoDialog-item CargoDialog-TrailerControls">
                    <div className="CargoDialog-inline CargoDialog-mobileMarginBottom">
                        <this.Control type="checkbox"
                            attribute={cargo.attributes.get('with_trailer')} />
                    </div>
                    {towBarType}
                </div>
            );
        }

        if (cargo.attributes.has('packing_methods')) {
            var packingMethodsAttribute = cargo.attributes.get('packing_methods');
            var packingMethodsOptions = Object.values(packingMethodsAttribute.values).map(option => {
                return {
                    value: option.id === 21 ? 0 : option.id,
                    label: option.value,
                    is_default: option.is_default,
                };
            }).sort(function (a, b) {
                return b.is_default - a.is_default;
            });

            additinalAttributes.packing_service = (
                <div className="CargoDialog-item CargoDialog-PackingControls">
                    <div className="CargoDialog-inline">
                        <this.Control
                            type="select"
                            label={cargo.attributes.get('packing_service').title}
                            options={packingMethodsOptions}
                            attribute={packingMethodsAttribute} />
                    </div>
                </div>
            );
        }

        var common = null;
        if (cargo.attributes.has('comment') || cargo.attributes.has('photo')) {
            common = (
                <div className="CargoDialog-commonAttributes" key="commonAttributes">
                    <CommonCargoAttributesPane
                        hasCommentAttribute={cargo.attributes.has('comment')}
                        hasPhotoAttribute={cargo.attributes.has('photo')}
                        commentValue={cargo.attributes.get('comment').value}
                        photoValue={cargo.getIn(['attributes', 'photo', 'value'])}
                        selectedCategory={this.props.selectedCategory} />
                </div>
            );
        }

        var content = [
            <div className="CargoDialog-validation" key="validation">
                {createFragment(validationResult)}
            </div>,
            <div className="CargoDialog-mainAttributes" key="mainAttributes">
                {createFragment(mainAttributes)}
            </div>,
            <div className="CargoDialog-additionalAttributes" key="additionalAttributes">
                <div className="CargoDialog-additionalAttributesTitleBox">
                    {this.props.selectedCategory &&
                        this.props.selectedCategory.id !== 'vehicle'
                        && this.props.selectedCategory.id !== 'animals'
                        && this.props.selectedCategory.id !== 'people' ?
                        <div>
                            <div className="CargoDialog-additionalAttributesTitle">
                                {t('ONE_PLACE_PARAMS')}
                            </div>
                            <TipControl className="CargoDialog-additionalAttributesTip" label={t('ONE_PLACE_PARAM_TIP')} />
                        </div> : ''}
                </div>
                {createFragment(additinalAttributes)}
            </div>,
            common
        ];

        var modalTitle = 'Добавьте первый груз';

        if (this.props.selectedCategory.id === 'people') {
            modalTitle = 'Добавьте пассажиров'

            if (EditingCargoStore.getIsSecondEditing()) {
                modalTitle = 'Редактирование параметров перевозки'
            };
        } else {
            if (this.props.deliveryCargos.size) {
                modalTitle = 'Добавьте новый груз'
            };

            if (EditingCargoStore.getIsSecondEditing()) {
                modalTitle = 'Редактирование параметров груза'
            };
        };


        return (
            <div className="CargoDialog">
                <Modal
                    title={modalTitle}
                    content={content}
                    onSave={this._onDialogSave}
                    onClose={this._onDialogClose.bind(this, 'cancelCargoDialog')}
                    buttonSaveId="save" />
            </div>
        );
    }

}

export default CargoDialog;



// WEBPACK FOOTER //
// ./client/components/CargoDialog/CargoDialog.js